/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import {WealthyEnv} from "helpers";
import styled from "styled-components";

const closeIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/invest/close.png`;

const propTypes = {
  children: PropTypes.string,
  dialogStatus: PropTypes.bool,
  toggleDialog: PropTypes.bool
};

const defaultProps = {
  children: ""
};

const Modal = ({
  dialogStatus,
  toggleDialog,
  children
}) => (
  <DialogWrapper>
    <DialogContent>
      <ModalHeader>
        <SafeLink href="#" onClick={() => toggleDialog(!dialogStatus)}>
          <img
            alt="close"
            src={closeIcon}
          />
        </SafeLink>
      </ModalHeader>
      <DialogBody>
        {children}
      </DialogBody>
    </DialogContent>
  </DialogWrapper>
);

const DialogWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* display: none; */
  align-items: center;
  justify-content: center;
  z-index: 10;
  padding: 20px;
`;

const DialogContent = styled.div`
  width: 720px;
  max-width: 100%;
  margin: 0 auto;
  animation: 0.3s slideDown ease-in-out;

  @keyframes slideDown {
    from {
      transform: translateY(-100px);
      opacity: 0;
    }

    to {
      transform: unset;
      opacity: 1;
    }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: end;
  padding: 0 10px 10px 0;

  img {
    height: 22px;
  }
`;

const DialogBody = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: $shadow-primary;
  overflow: hidden;
`;

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;
